import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../redux/configureStore';
import {
  convertToReal,
  convertToRealWithChecked,
} from '../../../../../../../utils/values';

export default function unifiedReportCsvData() {
  const accountingAppContext = useSelector(
    (reducer: IReducer) => reducer.accountingAppV2
  );

  const partnersValues = accountingAppContext.terceiros;
  const fiduciaValues = accountingAppContext.fiducia;
  const data = [
    {
      partnersType: 'Saldo',
      partnersLabels: 'SALDO INICIAL',
      partnersValues: convertToRealWithChecked(partnersValues.saldo_inicial),
      fiduciaType: 'Saldo',
      fiduciaLabels: 'SALDO INICIAL',
      fiduciaValues: convertToRealWithChecked(fiduciaValues.saldo_inicial),
    },
    {
      partnersType: 'TED',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.teds.valor_recebido
      ),
      fiduciaType: 'TED',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.teds.valor_recebido
      ),
    },
    {
      partnersType: 'TED',
      partnersLabels: 'Valor enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.teds.valor_enviado
      ),
      fiduciaType: 'TED',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(fiduciaValues.teds.valor_enviado),
    },
    {
      partnersType: 'PIX',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.pix.valor_recebido
      ),
      fiduciaType: 'PIX',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(fiduciaValues.pix.valor_recebido),
    },
    {
      partnersType: 'PIX',
      partnersLabels: 'Valor enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.pix.valor_enviado
      ),
      fiduciaType: 'PIX',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(fiduciaValues.pix.valor_enviado),
    },
    {
      partnersType: 'Tarifas Pagas à Fidúcia',
      partnersLabels: 'Valor Enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.tarifas_pagas_a_fiducia.valor_enviado
      ),
      fiduciaType: '#',
      fiduciaLabels: '#',
      fiduciaValues: '#',
    },
    {
      partnersType: 'Tarifas Pagas à WL',
      partnersLabels: 'Valor Recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.tarifas_pagas_a_wl.valor_recebido
      ),
      fiduciaType: '#',
      fiduciaLabels: '#',
      fiduciaValues: '#',
    },
    {
      partnersType: 'Tarifas Pagas à WL',
      partnersLabels: 'Valor Enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.tarifas_pagas_a_wl.valor_enviado
      ),
      fiduciaType: '#',
      fiduciaLabels: '#',
      fiduciaValues: '#',
    },
    {
      partnersType: 'Tarifas pagas (PIX/TED/Outras)',
      partnersLabels: '#',
      partnersValues: '#',
      fiduciaType: 'Tarifas pagas (PIX/TED/Outras)',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.tarifas_pagas.valor_enviado
      ),
    },
    {
      partnersType: 'Tarifas pagas (TIB/SLB)',
      partnersLabels: '#',
      partnersValues: '#',
      fiduciaType: 'Tarifas pagas (TIB/SLB)',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.tarifas_tib_slb.valor_recebido
      ),
    },
    {
      partnersType: 'Tarifas pagas (TIB/SLB)',
      partnersLabels: '#',
      partnersValues: '#',
      fiduciaType: 'Tarifas pagas (TIB/SLB)',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.tarifas_tib_slb.valor_enviado
      ),
    },
    {
      partnersType: 'Pagamento de Contas Celcoin',
      partnersLabels: 'Valor enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.pagamentos_celcoin.valor_enviado
      ),
      fiduciaType: 'Pagamento de Contas Celcoin',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.pagamentos_celcoin.valor_enviado
      ),
    },
    {
      partnersType: 'Pagamento de Contas Celcoin',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.pagamentos_celcoin.valor_recebido
      ),
      fiduciaType: 'Pagamento de Contas Celcoin',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.pagamentos_celcoin.valor_recebido
      ),
    },
    {
      partnersType: '#',
      partnersLabels: '#',
      partnersValues: '#',
      fiduciaType: 'FGTS',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.fgts.valor_recebido
      ),
    },
    {
      partnersType: '#',
      partnersLabels: '#',
      partnersValues: '#',
      fiduciaType: 'Investimento',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.investimento.valor_recebido
      ),
    },
    {
      partnersType: 'Recebimento de TEV Interna',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.recebimento_tev_interna.valor_recebido
      ),
      fiduciaType: 'Recebimento de TEV Interna',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.recebimento_tev_interna.valor_recebido
      ),
    },
    {
      partnersType: 'Recebimento de TEV Interna',
      partnersLabels: 'Valor enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.recebimento_tev_interna.valor_enviado
      ),
      fiduciaType: 'Recebimento de TEV Interna',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.recebimento_tev_interna.valor_enviado
      ),
    },
    {
      partnersType: 'Domicílio Bancário',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.domicilio_bancario.valor_recebido
      ),
      fiduciaType: 'Domicílio Bancário',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.domicilio_bancario.valor_recebido
      ),
    },
    {
      partnersType: 'Domicílio Bancário',
      partnersLabels: 'Valor enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.domicilio_bancario.valor_enviado
      ),
      fiduciaType: 'Domicílio Bancário',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.domicilio_bancario.valor_enviado
      ),
    },
    {
      partnersType: 'Boletos',
      partnersLabels: 'Valor enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.boletos_liquidados.valor_enviado
      ),
      fiduciaType: 'Boletos',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.boletos_liquidados.valor_enviado
      ),
    },
    {
      partnersType: 'Boletos',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.boletos_liquidados.valor_recebido
      ),
      fiduciaType: 'Boletos',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.boletos_liquidados.valor_recebido
      ),
    },
    {
      partnersType: 'TEVs',
      partnersLabels: 'Valor enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.tev_entre_ambiente.valor_enviado
      ),
      fiduciaType: 'TEVs',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.tev_entre_ambiente.valor_enviado
      ),
    },
    {
      partnersType: 'TEVs',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.tev_entre_ambiente.valor_recebido
      ),
      fiduciaType: 'TEVs',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.tev_entre_ambiente.valor_recebido
      ),
    },
    {
      partnersType: 'Cartão',
      partnersLabels: 'Valor enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.cartao.valor_enviado
      ),
      fiduciaType: 'Cartão',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.cartao.valor_enviado
      ),
    },
    {
      partnersType: 'Cartão',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.cartao.valor_recebido
      ),
      fiduciaType: 'Cartão',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.cartao.valor_recebido
      ),
    },
    {
      partnersType: 'Cripto',
      partnersLabels: 'Valor enviado',
      partnersValues: convertToRealWithChecked(
        partnersValues.cripto.valor_enviado
      ),
      fiduciaType: 'Cripto',
      fiduciaLabels: 'Valor enviado',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.cripto.valor_enviado
      ),
    },
    {
      partnersType: 'Cripto',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(
        partnersValues.cripto.valor_recebido
      ),
      fiduciaType: 'Cripto',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(
        fiduciaValues.cripto.valor_recebido
      ),
    },
    {
      partnersType: 'Saldo Final',
      partnersLabels: 'Valor recebido',
      partnersValues: convertToRealWithChecked(partnersValues.saldo_final),
      fiduciaType: 'Saldo Final',
      fiduciaLabels: 'Valor recebido',
      fiduciaValues: convertToRealWithChecked(fiduciaValues.saldo_final),
    },
  ];
  return data;
}

export function ClosedReportCsvData() {
  const data = useSelector((reducer: IReducer) => reducer.closedData);

  const content = [
    {
      index: 'RECEBIMENTO DE TRANSFERÊNCIAS',
      description: 'Recebimento de TED',
      code: 'STR0008R2',
      value: convertToReal(data.recebimento_transferencia_externa.STR0008R2),
    },
    {
      index: 'RECEBIMENTO DE TRANSFERÊNCIAS',
      description: 'Estorno de TED',
      code: 'STR0010R2',
      value: convertToReal(data.recebimento_transferencia_externa.STR0010R2),
    },
    {
      index: 'RECEBIMENTO DE TRANSFERÊNCIAS',
      description: 'Recebimento de IF para IF',
      code: 'STR0006R2',
      value: convertToReal(data.recebimento_transferencia_externa.STR0006R2),
    },
    {
      index: 'RECEBIMENTO DE TRANSFERÊNCIAS',
      description: 'Recebimento de TED',
      code: 'STR0007R2',
      value: convertToReal(data.recebimento_transferencia_externa.STR0007R2),
    },
    {
      index: 'RECEBIMENTO DE TRANSFERÊNCIAS',
      description: 'Pix',
      code: 'Pix',
      value: convertToReal(data.recebimento_transferencia_externa.Pix),
    },
    {
      index: 'RECEBIMENTO DE TRANSFERÊNCIAS',
      description: 'Pix Devolução',
      code: 'Pix_Devolucao',
      value: convertToReal(
        data.recebimento_transferencia_externa.Pix_Devolucao
      ),
    },
    {
      index: 'RECEBIMENTO DE TRANSFERÊNCIAS',
      description: 'Recebimento de transferência de outra IF',
      code: 'STR0004R2_FGTS',
      value: convertToReal(
        data.recebimento_transferencia_externa.STR0004R2_FGTS
      ),
    },
    {
      index: 'RECEBIMENTO DE TRANSFERÊNCIAS',
      description: 'Recebimento de transferência de outra IF',
      code: 'STR0004R2 (FIDÚCIA INVEST)',
      value: convertToReal(
        data.recebimento_transferencia_externa.STR0004R2_INVEST
      ),
    },
    {
      index: 'ENVIO DE TRANSFERÊNCIAS EXTERNAS',
      description: 'Recebimento de transferência de outra IF',
      code: 'TED',
      value: convertToReal(data.envio_transferencia_externa.STR0008),
    },
    {
      index: 'ENVIO DE TRANSFERÊNCIAS EXTERNAS',
      description: 'Pix',
      code: 'PIX',
      value: convertToReal(data.envio_transferencia_externa.Pix),
    },
    {
      index: 'ENVIO DE TRANSFERÊNCIAS EXTERNAS',
      description: 'Pix devolução',
      code: 'PIX devolução',
      value: convertToReal(data.envio_transferencia_externa.Pix_Devolucao),
    },
    {
      index: 'RECEBIMENTO DE DOMICÍLIO BANCÁRIO',
      description: 'Fluxo de Crédito - CIP',
      code: 'ASLC022',
      value: convertToReal(data.recebimento_domicilio_bancario.ASLC022),
    },
    {
      index: 'RECEBIMENTO DE DOMICÍLIO BANCÁRIO',
      description: 'Fluxo de Débito - CIP',
      code: 'ASLC032',
      value: convertToReal(data.recebimento_domicilio_bancario.ASLC032),
    },
    {
      index: 'RECEBIMENTO DE DOMICÍLIO BANCÁRIO',
      description: 'Fluxo de Antecipação - CIP',
      code: 'ASLC024',
      value: convertToReal(data.recebimento_domicilio_bancario.ASLC024),
    },
    {
      index: 'ENVIO DE TRANSFERÊNCIAS INTERNAS',
      description: 'TEV Interna',
      code: 'STR0008',
      value: convertToReal(data.envio_transferencia_interna.STR0008),
    },
    {
      index: 'ENVIO DE TRANSFERÊNCIAS INTERNAS PARA CONTAS DE TERCEIROS',
      description: 'TEV Interna',
      code: 'STR0008',
      value: convertToReal(
        data.envio_transferencia_interna_conta_terceiros.STR0008
      ),
    },
    {
      index: 'RECEBIMENTO DE TRANSFERÊNCIAS INTERNAS DE CONTAS FIDÚCIA',
      description: 'TEV Interna',
      code: 'STR0008',
      value: convertToReal(
        data.recebimento_transferencia_interna_conta_fiducia.STR0008
      ),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de Pix',
      code: 'TARIFA_PIX',
      value: convertToReal(data.recebimento_tarifas.TARIFA_PIX),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Recebimento de transferência de outra IF',
      code: 'STR0004R2 (TIB)',
      value: convertToReal(data.recebimento_tarifas.STR0004R2),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de Recebimento de Pix',
      code: 'Tarifa de Recebimento de Pix',
      value: convertToReal(data.recebimento_tarifas.TARIFA_RECEBIMENTO_PIX),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de Recebimento de Pix Devolução',
      code: 'Tarifa de Recebimento de Pix Devolução',
      value: convertToReal(
        data.recebimento_tarifas.TARIFA_RECEBIMENTO_PIX_DEVOLUCAO
      ),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de Recebimento de TED',
      code: 'Tarifa de Recebimento de TED',
      value: convertToReal(data.recebimento_tarifas.TARIFA_RECEBIMENTO_TED),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de Recebimento de TEV',
      code: 'Tarifa de Recebimento de TEV',
      value: convertToReal(data.recebimento_tarifas.TARIFA_RECEBIMENTO_TEV),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de Recebimento de Boleto',
      code: 'Tarifa de Recebimento de Boleto',
      value: convertToReal(data.recebimento_tarifas.TARIFA_RECEBIMENTO_BOLETO),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de Recebimento de Domicílio bancário',
      code: 'Tarifa de Recebimento de Domicílio bancário',
      value: convertToReal(
        data.recebimento_tarifas.TARIFA_RECEBIMENTO_DOMICILIO
      ),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de TED',
      code: 'STR0004',
      value: convertToReal(data.recebimento_tarifas.TAXA_TED),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de boleto liquidado',
      code: 'TARIFA_BOLETO',
      value: convertToReal(data.recebimento_tarifas.TARIFA_BOLETO),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa genérica',
      code: 'TARIFA',
      value: convertToReal(data.recebimento_tarifas.TARIFA),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de boleto vencido',
      code: 'TARIFA_BOLETO_VENCIDO',
      value: convertToReal(data.recebimento_tarifas.TARIFA_BOLETO_VENCIDO),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de mensalidade',
      code: 'TARIFA_MENSAL',
      value: convertToReal(data.recebimento_tarifas.TARIFA_MENSAL),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de alteração de boleto',
      code: 'TARIFA_ALTERACAO_BOLETO',
      value: convertToReal(data.recebimento_tarifas.TARIFA_ALTERACAO_BOLETO),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de boleto baixado',
      code: 'TARIFA_BAIXADO',
      value: convertToReal(data.recebimento_tarifas.TARIFA_BAIXADO),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de abertura de conta PF',
      code: 'TARIFA_ABERTURA_CONTA_PF',
      value: convertToReal(data.recebimento_tarifas.TARIFA_ABERTURA_CONTA_PF),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de abertura de conta PJ',
      code: 'TARIFA_ABERTURA_CONTA_PJ',
      value: convertToReal(data.recebimento_tarifas.TARIFA_ABERTURA_CONTA_PJ),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de abertura de conta escrow',
      code: 'TARIFA_ABERTURA_CONTA_ESCROW',
      value: convertToReal(
        data.recebimento_tarifas.TARIFA_ABERTURA_CONTA_ESCROW
      ),
    },
    {
      index: 'RECEBIMENTO DE TARIFAS',
      description: 'Tarifa de abertura de conta Consignada',
      code: 'TARIFA_ABERTURA_CONTA_CONSIGNADA',
      value: convertToReal(
        data.recebimento_tarifas.TARIFA_ABERTURA_CONTA_CONSIGNADA
      ),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de Pix',
      code: 'TAXA_TED',
      value: convertToReal(data.repasse_tarifas.TAXA_TED),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Recebimento de transferência para outra IF',
      code: 'SLB0002',
      value: convertToReal(data.repasse_tarifas.SLB0002),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de Recebimento de Pix',
      code: 'Tarifa de Recebimento de Pix',
      value: convertToReal(data.repasse_tarifas.TARIFA_RECEBIMENTO_PIX),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de Recebimento de Pix Devolução',
      code: 'Tarifa de Recebimento de Pix Devolução',
      value: convertToReal(
        data.repasse_tarifas.TARIFA_RECEBIMENTO_PIX_DEVOLUCAO
      ),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de Recebimento de TED',
      code: 'Tarifa de Recebimento de TED',
      value: convertToReal(data.repasse_tarifas.TARIFA_RECEBIMENTO_TED),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de Recebimento de TEV',
      code: 'Tarifa de Recebimento de TEV',
      value: convertToReal(data.repasse_tarifas.TARIFA_RECEBIMENTO_TEV),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de Recebimento de Boleto',
      code: 'Tarifa de Recebimento de Boleto',
      value: convertToReal(data.repasse_tarifas.TARIFA_RECEBIMENTO_BOLETO),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de Recebimento de Domicílio bancário',
      code: 'Tarifa de Recebimento de Domicílio bancário',
      value: convertToReal(data.repasse_tarifas.TARIFA_RECEBIMENTO_DOMICILIO),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de TED',
      code: 'STR0004',
      value: convertToReal(data.repasse_tarifas.STR0004),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de Pix',
      code: 'TARIFA_PIX',
      value: convertToReal(data.repasse_tarifas.TARIFA_PIX),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de boleto liquidado',
      code: 'TARIFA_BOLETO',
      value: convertToReal(data.repasse_tarifas.TARIFA_BOLETO),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa genérica',
      code: 'TARIFA',
      value: convertToReal(data.repasse_tarifas.TARIFA),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa Boleto vencido',
      code: 'TARIFA_BOLETO_VENCIDO',
      value: convertToReal(data.repasse_tarifas.TARIFA_BOLETO_VENCIDO),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa Mensal',
      code: 'TARIFA_MENSAL',
      value: convertToReal(data.repasse_tarifas.TARIFA_MENSAL),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa Alteração de Boleto',
      code: 'TARIFA_ALTERACAO_BOLETO',
      value: convertToReal(data.repasse_tarifas.TARIFA_ALTERACAO_BOLETO),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de Boleto baixado',
      code: 'TARIFA_BAIXADO',
      value: convertToReal(data.repasse_tarifas.TARIFA_BAIXADO),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de abertura de conta PF',
      code: 'TARIFA_ABERTURA_CONTA_PF',
      value: convertToReal(data.repasse_tarifas.TARIFA_ABERTURA_CONTA_PF),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de abertura de conta PJ',
      code: 'TARIFA_ABERTURA_CONTA_PJ',
      value: convertToReal(data.repasse_tarifas.TARIFA_ABERTURA_CONTA_PJ),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de abertura de conta Escrow',
      code: 'TARIFA_ABERTURA_CONTA_ESCROW',
      value: convertToReal(data.repasse_tarifas.TARIFA_ABERTURA_CONTA_ESCROW),
    },
    {
      index: 'REPASSE DE TARIFAS',
      description: 'Tarifa de abertura de conta Consignada',
      code: 'TARIFA_ABERTURA_CONTA_CONSIGNADA',
      value: convertToReal(
        data.repasse_tarifas.TARIFA_ABERTURA_CONTA_CONSIGNADA
      ),
    },
    {
      index: 'RECEBIMENTO DE BOLETO ITAÚ',
      description: 'Recebimento de boleto',
      code: 'BOLETO_CREDITO',
      value: convertToReal(data.recebimento_boleto_itau.BOLETO_CREDITO),
    },
    {
      index: 'RECEBIMENTO DE BOLETOS CONTA FIDÚCIA',
      description: 'Recebimento de boleto',
      code: 'BOLETO_CREDITO',
      value: convertToReal(data.recebimento_boleto_fiducia.BOLETO_CREDITO),
    },
    {
      index: 'RECEBIMENTO DE BOLETOS CONTA TERCEIROS',
      description: 'Boletos liquidados para terceiros',
      code: 'BOLETO_CREDITO',
      value: convertToReal(data.recebimento_boleto_terceiros.BOLETO_CREDITO),
    },
    {
      index: 'PAGAMENTO DE BOLETOS',
      description: 'Pagamento de boleto',
      code: 'BOLETO_CREDITO',
      value: convertToReal(data.recebimento_boleto_terceiros.BOLETO_CREDITO),
    },
    {
      index: 'RECEBIMENTO BOLETO',
      description: 'Recebimeneto de boleto',
      code: 'BOLETO_CREDITO',
      value: convertToReal(data.recebimento_boleto.BOLETO_CREDITO),
    },
    {
      index: 'RECEBIMENTO BOLETO',
      description: 'Recebimeneto de boleto',
      code: 'BOLETO',
      value: convertToReal(data.recebimento_boleto.Boleto),
    },
    {
      index: 'PAGAMENTO DE BOLETOS',
      description: 'Pagamento de boleto',
      code: 'Boleto',
      value: convertToReal(data.pagamento_boleto.Boleto),
    },
    {
      index: 'RECEBIMENTO DE RECARGAS',
      description: 'Recarga',
      code: 'Recarga',
      value: convertToReal(data.recebimento_recarga.Recarga),
    },
    {
      index: 'PAGAMENTO DE RECARGAS',
      description: 'Recarga',
      code: 'Recarga',
      value: convertToReal(data.pagamento_recarga.Recarga),
    },
    {
      index: 'ENVIO CARTÃO',
      description: 'Compra via cartão',
      code: 'CARTAO_00_PURCHASE',
      value: convertToReal(data.envio_cartao.CARTAO_00_PURCHASE),
    },
    {
      index: 'ENVIO CARTÃO',
      description: 'Saque via cartão',
      code: 'CARTAO_01_CASH_WITHDRAW',
      value: convertToReal(data.envio_cartao.CARTAO_01_CASH_WITHDRAW),
    },
    {
      index: 'RECEBIMENTO CARTÃO',
      description: 'Compra via cartão',
      code: 'CARTAO_00_PURCHASE',
      value: convertToReal(data.recebimento_cartao.CARTAO_00_PURCHASE),
    },
    {
      index: 'RECEBIMENTO DO CARTÃO',
      description: 'Saque via cartão',
      code: 'CARTAO_01_CASH_WITHDRAW',
      value: convertToReal(data.recebimento_cartao.CARTAO_01_CASH_WITHDRAW),
    },
  ];

  return content;
}
